import { observable } from "mobx";
import AgendamentoContainerService from "../../../../services/AgendamentoContainerService";
import lscache from "lscache";
import _ from 'lodash';
import moment from 'moment';
import { splitBR } from "../../../../utils/formatar";

export default class NotaFiscalCadastrarStore {

    @observable idNota;
    @observable dadosNotaFiscal;
    @observable terminal;

    // Select
    @observable transportadorasNotaFiscal;
    @observable paises;
    @observable UFs;
    @observable paisSelecionado;

    @observable flagAtivo;
    @observable atualizaBagagem;

    // Adicionar por modais
    @observable codigoNovo;
    posNotaFiscalNovoContainer;

    @observable salvar;
    @observable sucesso;
    @observable mensagemErro;
    @observable notaNaoEncontrada;
    @observable atualiza;
    @observable atualizaCNPJEmiss;
    @observable atualizaCNPJDest;
    @observable loading;
    @observable dataInicio;
    @observable dataFim;
    @observable contemErro;
    @observable validado

    camposObrigatorios;

    constructor() {
        this.idNota = false;
        this.dadosNotaFiscal = [];
        this.terminal = "";

        // Geral
        this.transportadorasNotaFiscal = [];
        this.paises = [];
        this.UFs = [];
        this.dataInicio = false;
        this.dataFim = false;
        this.paisSelecionado = false;
        this.flagAtivo = false;
        this.atualizaBagagem = true;

        this.service = new AgendamentoContainerService();

        this.salvar = false;
        this.sucesso = false;
        this.notaNaoEncontrada = false;
        this.mensagemErro = [];
        this.mensagemSucesso = "Nota Fiscal salva com sucesso";

        this.dadosNotaFiscal = {
            "Nf": {
                "Id": 0,
                "Status": "P",
                "CnpjEmissor_lblNaoExiste": "",
                "CnpjDestinatario_lblNaoExiste": ""
            },
            "ListaCntr": [],
            "ListaItem": []
        };

        this.camposZerados = ["ValIpi", "ValIcms", "Operacao", "CodCfop", "Membershipuserid", "TruckVisitAppointmentNbr", "TranspId", 'ParcIdEmiss', 'EstabIdEmiss', 'QtdTotal', 'ValTotal', 'PesoTotal', 'QtdTotal'];
        this.camposNulos = ["ChaveNfe", "SerieNotaTransp", "NumBooking", "FlagBagagem", "Ruc", "StatusDue", "FlagBitrem", "XmlNota", 'NumNotaTransp', 'Cnpjs', 'CdPaisDest', 'CdUnidadeFedDest', 'NomCidadeDest'];
        this.camposNaoObrigatorios = ['CnpjDest', 'RazaoSocialDest', 'RazaoSocialEmissor', 'InscrEstadDest'];

        this.atualiza = true;
        this.atualizaCNPJEmiss = true;
        this.atualizaCNPJDest = true;
        this.loading = !!this.idNota;
        this.contemErro = false;
        this.carregouNF = false;
        this.validado = true;
    }

    carregarTransportadorasNotaFiscal = async (valor) => {
        try {
            const { data } = await this.service.listarTransportadoras(valor)
            this.transportadorasNotaFiscal = data;
        } catch (error) {
            console.log(`Erro ao carregar lista de tranportadora: ${error}`)
        }
    };

    carregarPaises = () => {
        this.paises = [];
        this.service.listarPaises().then(response => {
            this.paises = response.data;
        }).catch(error => {
            console.log(error);
        })
    };

    carregarUFs = (pais) => {
        this.UFs = [];
        this.service.listarUFs(pais).then(response => {
            if (response.data && response.data.length > 0) {
                this.UFs = response.data;
            } else {
                this.UFs = [];
            }
        }).catch(error => {
            console.log(error);
        });
    };

    carregarNota = (id) => {
        this.loading = true;
        this.service.carregarNota(id).then(response => {
            if (response && response.data) {
                this.formatarNotaSelecionada(_.get(response.data, 'notaFiscal'), _.get(response.data, 'containers'), _.get(response.data, 'items'))

                if (_.get(response.data, `notaFiscal.CdPaisDest`)) {
                    this.setPais(_.get(response.data, `notaFiscal.CdPaisDest`), false);
                }

                if (_.get(response.data, 'notaFiscal.FlagBagagem') == 'V' || _.get(response.data, 'notaFiscal.FlagBitrem') == 'S') {
                    this.flagAtivo = true;
                }

            } else {
                this.notaNaoEncontrada = true;
            }
        }).catch(error => {
            console.log(error);
        }).finally(() => { this.loading = false; })
    };

    carregarNotaSelecionada = (nota, duplicar) => {
        if (nota) {
            if (duplicar) {
                this.carregarNota(_.get(nota, 'NotaFiscalTranspId'));
            }
            this.dadosNotaFiscalSelecionada = nota;
            this.formatarNotaSelecionada(this.dadosNotaFiscalSelecionada, _.get(this.dadosNotaFiscalSelecionada, 'ListaCntr'), _.get(this.dadosNotaFiscalSelecionada, 'ListaItem'));
        }
    };

    carregaCamposObrigatoriosNotasFiscais = (bagagemFlag = false) => {
        this.camposObrigatorios = this.service.buscarCamposObrigatoriosNotas(bagagemFlag);
    };

    formatarNotaSelecionada = (nf, listaContainer, listaNCM) => {
        _.set(this.dadosNotaFiscal, 'Nf', nf);
        _.set(this.dadosNotaFiscal, 'ListaCntr', listaContainer ? listaContainer : []);
        _.set(this.dadosNotaFiscal, 'ListaItem', listaNCM ? listaNCM : []);
        _.set(this.dadosNotaFiscal, 'Nf.Id', this.idNota);
        if (_.get(this.dadosNotaFiscal, 'Nf.Cnpjs')) {
            this.setCNPJEmissor('Nf.Cnpjs', _.get(this.dadosNotaFiscal, 'Nf.Cnpjs'));
        }
        if (_.get(this.dadosNotaFiscal, 'Nf.CnpjDest')) {
            this.setCNPJDestinatarioSemPensar('Nf.CnpjDest', _.get(this.dadosNotaFiscal, 'Nf.CnpjDest'));
        }
        if (_.get(this.dadosNotaFiscal, 'Nf.CdPaisDest')) {
            this.setPais(_.get(this.dadosNotaFiscal, 'Nf.CdPaisDest'), false);
        }
        if (_.get(this.dadosNotaFiscal, 'Nf.CdPaisDest')) {
            this.setPais(_.get(this.dadosNotaFiscal, 'Nf.CdPaisDest'), false);
        }
    };

    setCamposNotaComVal = (arr, val) => {
        if (arr && arr.length > 0) {
            arr.map(e => {
                if (!_.get(this.dadosNotaFiscal, `Nf.${e}`)) {
                    _.set(this.dadosNotaFiscal, `Nf.${e}`, val)
                }
            });
        }
    };

    setIdNota = (id) => {
        this.idNota = id;
    };

    setDadosNotaFiscal = (campo, event) => {
        this.carregouNF = true;

        if(campo == "Nf.FlagBitrem") {
            if(event.value.includes('S')) {
                this.flagAtivo = true;
            } else {
                this.flagAtivo = false;
            }
        }

        if (event) {
            if (event.target) {
                if (event.target.value != "") _.set(this.dadosNotaFiscal, campo, event.target.value)
                else this.dadosNotaFiscal = _.omit(this.dadosNotaFiscal, campo)
            } else {
                _.set(this.dadosNotaFiscal, campo, event.value ? event.value : event)
            }
        } else {
            this.dadosNotaFiscal = _.omit(this.dadosNotaFiscal, campo)
        }
    };

    //Essa função pode ser passada para inputs que possuem validadores
    //Da forma atual se um input estiver invalido ele não armazena o valor incorreto
    //Logo essa função seta uma variável indicando que há algum form invalido
    //De preferencia, essa função recebe um booleano
    setValidacao = (value) => {
        this.validado = value
    }

    removerNotaFiscal = (index) => {
        this.dadosNotaFiscal.splice(index, 1)
    };

    // Containers de Nota Fiscal
    abrirInserirNovoNotaFiscalContainer = (posNotaFiscal) => {
        this.posNotaFiscalNovoContainer = posNotaFiscal;
        this.adicionarNovaNotaFiscalContainer();
    };

    adicionarNovaNotaFiscalContainer = () => {
        if (_.has(this.dadosNotaFiscal, 'ListaCntr')) {
            this.dadosNotaFiscal.ListaCntr.push({ 'CnpjCobrade': 0 });
        } else {
            let lista = new observable([]);
            _.set(this.dadosNotaFiscal, `ListaCntr`, lista);
            this.dadosNotaFiscal.ListaCntr.push({ 'CnpjCobrade': 0 });
        }
        this.fecharModais();
    };

    removerNotaFiscalContainer = (pos, index) => {
        this.dadosNotaFiscal[pos].ListaCntr.splice(index, 1)
    };

    // NCM de Nota Fiscal
    abrirInserirNovoNotaFiscalNCM = (posNotaFiscal) => {
        this.posNotaFiscalNovoContainer = posNotaFiscal;
        this.adicionarNovaNotaFiscalNCM();
    };

    adicionarNovaNotaFiscalNCM = () => {
        if (_.has(this.dadosNotaFiscal, 'ListaItem')) {
            this.dadosNotaFiscal.ListaItem.push({ Id: 0, NotaFiscalTranspId: _.get(this.dadosNotaFiscal, `Nf.NotaFiscalTranspId`), IndExcluido: 'N' });
        } else {
            let lista = new observable([]);
            _.set(this.dadosNotaFiscal, `ListaItem`, lista)
            this.dadosNotaFiscal.ListaItem.push({});
        }
        this.fecharModais();
    };

    fecharModais = () => {
        this.codigoNovo = "";
        this.mensagemErro = [];
        this.sucesso = false;
    };

    finalizarEdicao = () => {
        this.fecharModais();
        this.carregarNota(this.idNota);
    };

    onClickSalvarNotaFiscal = () => {
        this.salvar = true;

        if (!this.validado) {
            this.mensagemErro = ["Algum campo está inválido. Por favor, verifique suas informações."];
            this.salvar = false;
            return false;
        }

        //TODO - REMOVER VALIDAÇÃO
        //this.validarCampos();
        if (this.salvar) {

            this.formatNaoObrigatorios();
            this.formatInserirNCMs();
            this.formatInserirContainers();

            this.setCamposNotaComVal(this.camposZerados, 0);
            this.setCamposNotaComVal(this.camposNulos, null);

            this.limparIdsItens();

            this.service.salvarNota(this.dadosNotaFiscal).then(response => {
                this.salvar = false;
                if (response.data) {
                    this.sucesso = _.get(response.data, "Sucesso");
                    if (!this.sucesso) {
                        let msg = _.get(response.data, "Mensagem") ? _.get(response.data, "Mensagem") : "Ops! Infelizmente ocorreu um erro inesperado.";
                        this.mensagemErro = msg && splitBR(msg);
                    }
                } else
                    console.log("Problemas ao salvar");
            }).catch(err => {
                console.log(err);
            });
        }
    };

    onClickEditarNotaFiscal = () => {
        {/** TODO: REFATORAR código duplicado */ }
        this.salvar = true;

        if (!this.validado) {
            this.mensagemErro = ["Algum campo está inválido. Por favor, verifique suas informações."];
            this.salvar = false;
            return false;
        }

        if (this.salvar) {

            this.formatNaoObrigatorios();
            this.formatInserirNCMs();
            this.formatInserirContainers();
            //this.formatCheckboxes();

            this.service.editarNota(this.dadosNotaFiscal).then(response => {
                this.salvar = false;
                if (response.data) {
                    this.sucesso = _.get(response.data, "Sucesso");
                    if (!this.sucesso) {
                        let msg = _.get(response.data, "Mensagem");
                        this.mensagemErro = msg && splitBR(msg);
                    }
                } else
                    console.log("Problemas ao salvar");
            }).catch(err => {
                console.log(err);
            });
        }
    };

    setPais = (valor, limpaUfCidade = true) => {
        if (limpaUfCidade) {
            this.setDadosNotaFiscal(`Nf.CdUnidadeFedDest`, "");
            this.setDadosNotaFiscal(`Nf.NomCidadeDest`, "");
        }
        if (valor && (valor.value === "BR" || valor === "BR")) {
            this.paisSelecionado = valor;
            this.carregarUFs(_.get(this.paisSelecionado, `value`) ? this.paisSelecionado.value : this.paisSelecionado);
        }
        else {
            this.paisSelecionado = false;
            this.setDadosNotaFiscal(`Nf.CdUnidadeFedDest`, "EX");
            this.setDadosNotaFiscal(`Nf.NomCidadeDest`, "EXTERIOR");
        }
    };

    formatNaoObrigatorios = () => {
        let naoSetados = [];
        this.camposNaoObrigatorios.map(
            item => {
                if (!_.get(this.dadosNotaFiscal, item)) {
                    naoSetados.push(item);
                }
            });

        this.setCamposNotaComVal(naoSetados, '');
    };

    formatInserirNCMs = () => {
        this.dadosNotaFiscal.ListaItem.map(item => {
            item['MercId'] = item['MercId'] ? item['MercId'] : 0;
            item['NcmMerc'] = item['NcmMerc'] ? item['NcmMerc'] : null;
            item['Id'] = item['Id'] ? item['Id'] : 0;
            item['IndExcluido'] = item['IndExcluido'] ? item['IndExcluido'] : 'N';
            item['NotaFiscalTranspId'] = _.get(this.dadosNotaFiscal, `Nf.TranspId`);
            item['QtdItem'] = item['QtdItem'] ? item['QtdItem'] : 0;
            item['ValItem'] = item['ValItem'] ? item['ValItem'] : 0;
            item['PesoItem'] = item['PesoItem'] ? item['PesoItem'] : 0;
            item['CodCfop'] = item['CodCfop'] ? item['CodCfop'] : 0;
        });
    };

    formatInserirContainers = () => {
        this.dadosNotaFiscal.ListaCntr.map(item => {
            item['Id'] = item['Id'] ? item['Id'] : 0;
            item['NumGuiaCaminhao'] = item['NumGuiaCaminhao'] ? item['NumGuiaCaminhao'] : 0;
            item['UnitGkey'] = item['UnitGkey'] ? item['UnitGkey'] : 0;
            item['Status'] = item['Status'] ? item['Status'] : "P";
            item['StatusDue'] = item['StatusDue'] ? item['StatusDue'] : null;
            item['CntId'] = item['CntId'] ? item['CntId'] : 0;
            item['CodCntr'] = item['CodCntr'] ? item['CodCntr'] : '';
            item['NumBooking'] = item['NumBooking'] ? item['NumBooking'] : '';
            item['IndExcluido'] = item['IndExcluido'] ? item['IndExcluido'] : 'N';
            item['NotaFiscalTranspId'] = item['NotaFiscalTranspId'] ? item['NotaFiscalTranspId'] : 0;
        });
    };

    /** TODO: refatorar (código muito parecido com removerContainer: usar uma função so pros 2)*/
    removerNCM = (index) => {
        this.atualiza = false;

        if (_.get(this.dadosNotaFiscal.ListaItem[index], 'Id')) {
            _.set(this.dadosNotaFiscal.ListaItem[index], `IndExcluido`, 'S');
        } else {
            this.dadosNotaFiscal.ListaItem.splice(index, 1);
        }

        setTimeout(function () {
            this.atualiza = true;
        }.bind(this), 1)
    };

    /** TODO: refatorar (código muito parecido com removerNCM: usar uma função so pros 2)*/
    removerContainer = (index) => {
        this.atualiza = false;

        if (_.get(this.dadosNotaFiscal.ListaCntr[index], 'Id')) {
            _.set(this.dadosNotaFiscal.ListaCntr[index], `IndExcluido`, 'S');
        } else {
            this.dadosNotaFiscal.ListaCntr.splice(index, 1);
        }

        setTimeout(function () {
            this.atualiza = true;
        }.bind(this), 1)
    };

    setCamposExtrasCNPJ = (dadosEmpresa) => {
        _.set(this.dadosNotaFiscal, 'Nf.ParcIdEmiss', dadosEmpresa.IdParceiro);
        _.set(this.dadosNotaFiscal, 'Nf.EstabIdEmiss', dadosEmpresa.IdEstab);
        _.set(this.dadosNotaFiscal, 'Nf.RazaoSocialEmissor', dadosEmpresa.Razao);
        _.set(this.dadosNotaFiscal, 'Nf.CnpjEmissor_lblNaoExiste', "");
    };

    limparCamposExtrasCNPJ = () => {
        _.set(this.dadosNotaFiscal, 'Nf.ParcIdEmiss', 0);
        _.set(this.dadosNotaFiscal, 'Nf.EstabIdEmiss', 0);
        _.set(this.dadosNotaFiscal, 'Nf.RazaoSocialEmissor', "");
        _.set(this.dadosNotaFiscal, 'Nf.CnpjEmissor_lblNaoExiste', 'Cliente não cadastrado');
    };

    limparIdsItens = () => {

        let listaItem = _.get(this.dadosNotaFiscal, `ListaItem`);
        if (listaItem && listaItem.length > 0) {
            listaItem.map((item, index) => {
                _.set(this.dadosNotaFiscal, `ListaItem[${index}].Id`, 0);
                _.set(this.dadosNotaFiscal, `ListaItem[${index}].NotaFiscalTranspId`, 0);
            });
        }

        let listaCntr = _.get(this.dadosNotaFiscal, `ListaCntr`);
        if (listaCntr && listaCntr.length > 0) {
            listaCntr.map((item, index) => {
                _.set(this.dadosNotaFiscal, `ListaCntr[${index}].Id`, 0);
                _.set(this.dadosNotaFiscal, `ListaCntr[${index}].NotaFiscalTranspId`, 0);
            });
        }

    };

    setCNPJEmissor = (campo, valor) => {

        this.setDadosNotaFiscal(campo, valor);

        if (valor) {
            //_.set(this.dadosNotaFiscal, 'Nf.CnpjEmissor_lblNaoExiste', 'Buscando CNPJ');
            _.set(this.dadosNotaFiscal, 'Nf.RazaoSocialEmissor', "");
            this.service.buscarParceiro(valor).then(response => {
                response && response.data ? this.setCamposExtrasCNPJ(response.data) : this.limparCamposExtrasCNPJ();

                let notaModificada = this.dadosNotaFiscal;
                this.dadosNotaFiscal = [];
                this.dadosNotaFiscal = notaModificada;
            });
        } else {
            this.limparCamposExtrasCNPJ();
        }

        this.atualizaCNPJEmiss = false;
        setTimeout(function () {
            this.atualizaCNPJEmiss = true;
        }.bind(this), 1)
    };

    setCNPJDestinatario = (campo, valor) => {
        this.setDadosNotaFiscal(campo, valor);
        if (valor) {
            _.set(this.dadosNotaFiscal, 'Nf.RazaoSocialDest', "");
            //_.set(this.dadosNotaFiscal, 'Nf.CnpjDestinatario_lblNaoExiste', 'Buscando CNPJ');
            this.service.buscarParceiro(valor).then(response => {
                if (response.data) {
                    _.set(this.dadosNotaFiscal, 'Nf.RazaoSocialDest', response.data.Razao);
                    _.set(this.dadosNotaFiscal, 'Nf.CnpjDestinatario_lblNaoExiste', "");
                } else {
                    _.set(this.dadosNotaFiscal, 'Nf.RazaoSocialDest', '');
                    _.set(this.dadosNotaFiscal, 'Nf.CnpjDestinatario_lblNaoExiste', "Cliente não cadastrado");
                }

                let notaModificada = this.dadosNotaFiscal;
                this.dadosNotaFiscal = [];
                this.dadosNotaFiscal = notaModificada;
            });
        } else {
            _.set(this.dadosNotaFiscal, 'Nf.CnpjDest', null);
            _.set(this.dadosNotaFiscal, 'Nf.RazaoSocialDest', '');
        }

        this.atualizaCNPJDest = false;
        setTimeout(function () {
            this.atualizaCNPJDest = true;
        }.bind(this), 1)
    };

    setCNPJDestinatarioSemPensar = (campo, valor) => {
        this.setDadosNotaFiscal(campo, valor);
    };

    validarCampos = () => {
        //this.carregaCamposObrigatoriosNotasFiscais(this.dadosNotaFiscal.Nf.FlagBagagem=='V');
        //let camposObrigatorios = this.camposObrigatorios.reverse();

        /*camposObrigatorios.map( campoObrigatorio =>{
            if ((_.get(this.dadosNotaFiscal.Nf , campoObrigatorio.Cod)===undefined)){
                this.salvarMensagemErroNota(campoObrigatorio.Label);
            } else if(_.get(this.dadosNotaFiscal.Nf , campoObrigatorio.Cod) === null || _.get(this.dadosNotaFiscal.Nf , campoObrigatorio.Cod) === ''){
                    this.salvarMensagemErroNota(campoObrigatorio.Label);
            }
        });*/
    };

    salvarMensagemErroNota = (campoLabel) => {
        this.contemErro = false
        this.mensagemErro.push([`Preencha o campo '${campoLabel}'.`]);
        this.salvar = false;
        setTimeout(() => {
            this.contemErro = true;
        }, 1)
    };
}



// WEBPACK FOOTER //
// ./src/modules/agendamento/nota-fiscal-cadastrar/stores/NotaFiscalCadastarStore.js